import { render, staticRenderFns } from "./SingleShipment.vue?vue&type=template&id=393557e4&scoped=true&"
import script from "./SingleShipment.vue?vue&type=script&lang=js&"
export * from "./SingleShipment.vue?vue&type=script&lang=js&"
import style0 from "./SingleShipment.vue?vue&type=style&index=0&id=393557e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393557e4",
  null
  
)

export default component.exports